import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UnrModalDismissEventEnum} from '../unr-modal-dismiss-event.enum';
import {UnrModalComponent} from '../unr-modal.component';
import {ModalController, NavParams} from '@ionic/angular';

@Component({
  selector: `unr-setting-recording-accuracy-modal`,
  templateUrl: 'setting-recording-accuracy-modal.component.html',
  styleUrls: [`../unr-modal.component.scss`]
})
export class UnrSettingRecordingAccuracyModalComponent implements OnInit {

  static readonly DISMISS_DATA_KEY = 'modalDismissData';

  @Input() title = 'Recording Accuracy';
  @Input() description = 'Specify your recording accuracy.';
  @Input() secondaryLabel = 'Cancel';
  @Input() primaryLabel = 'OK';
  @Input() min = 0;
  @Input() max = 100;

  value = 0;
  invertedValue = 0;
  color = 'success';

  constructor(private modalController: ModalController,
              private navParams: NavParams) {
  }

  ngOnInit(): void {
    this.invertedValue = this.navParams.get('invertedValue');
    this.value = this.max - this.invertedValue;
  }

  onChange(event: CustomEvent): void {
    const value = event.detail.value;
    this.invertedValue = this.max - value;
    if (value > 85 || value < 60) {
      this.color = 'danger';
    } else {
      this.color = 'success';
    }
  }

  onSecondaryClick(): void {
    this.modalController.dismiss({
      [UnrModalComponent.DISMISS_DATA_KEY]: UnrModalDismissEventEnum.Secondary,
    });
  }

  onPrimaryClick(): void {
    this.modalController.dismiss({
      [UnrModalComponent.DISMISS_DATA_KEY]: UnrModalDismissEventEnum.Primary,
      [UnrModalComponent.DISMISS_VALUE_KEY]: this.invertedValue
    });
  }
}
